import angular from "angular";
import panel from "../services";

function profileHome (panel) {

    return {
        restrict: 'E',
        scope: {
            pc: '='
        },
        link: function(scope) {
          let elem = new Foundation.Tabs($("#profile-tabs"), {});
        },
        template: require('./templates/profile/home.html')
    }
};

export default angular.module('directives.profileHome', [panel]).directive('profileHome', profileHome).name;



// WEBPACK FOOTER //
// ./src/app/directives/profileHome.js